import { render, staticRenderFns } from "./FinanceRatioTable.vue?vue&type=template&id=2fd57391&scoped=true"
import script from "./FinanceRatioTable.vue?vue&type=script&lang=js"
export * from "./FinanceRatioTable.vue?vue&type=script&lang=js"
import style0 from "./FinanceRatioTable.vue?vue&type=style&index=0&id=2fd57391&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd57391",
  null
  
)

export default component.exports